module.exports = __webpack_public_path__ + "media/images/shared/suppliers/COVIND-2a26dbc91396bf8d0ec6f7770a341dca.jpg";